export default __webpack_public_path__ + "static/LP-03022025-5c8e99422dbaf455c65d2c5af4531d3d.jpg";